export default "__VITE_ASSET__B7Dpn0UJ__"